module.exports = __webpack_public_path__ + "bca65e0d8377df22401699b4efdf827f.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/icons/icon-ecpe.png
// module id = 3218
// module chunks = 69